import { loadable } from '@shared/core/loadableFromNamedExport';

/** Code-split entry for the Bloom motion type; loads only when Motion resolves on. */
export const LazyBloom = loadable(() => import(/* webpackChunkName: "content/guest/header/motion/bloom" */ './Bloom'), 'Bloom');
